<template>
  <span>
    <i :class="typeList[icon].icon"></i> {{ showDescription ? typeList[icon].description : "" }}
  </span>
</template>

<script>

  import SrvService from "@/services/srv-service"

  export default {

    name: "ServiceType",

    data() {
      return {
        typeList: SrvService.TYPE_ICONS,
      }
    },

    props: {
      icon: { type: String, required: true },
      showDescription: { type: Boolean, default: false },
    }, 

  }
</script>